import { Dropdown, Form, Menu, message } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import {
  BlockLeft,
  BlockRight,
  DocumentContentWrapper,
  DocumentInfoList,
  HeadingButtonWrapper,
} from './SameDocumentIncomingDocDetailPageStyled'
// PDF Viewer
import {
  CalendarOutlined,
  InboxOutlined,
  MoreOutlined,
  ProfileOutlined,
  ReloadOutlined,
} from '@ant-design/icons'
import moment from 'moment'
import { useMediaQuery } from 'react-responsive'
import { blue } from '../../color'
import {
  EmptyText,
  TitleContentBox,
  WordBreak,
} from '../../components/Common/CellText'
import FileItem from '../../components/Common/FileItemComponent/FileItem'
import PDFViewer from '../../components/PDFViewer/PDFViewer'
import { systemName } from '../../config'
import {
  ACL_ACTION_TYPE,
  DATE_FORMAT_DEFAULT,
  getDOCUMENT_SAME_STATUS_RECEIVED,
} from '../../constants'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import utils from '../../utils'

const SameDocumentIncomingDocDetailPage = props => {
  const [form] = Form.useForm()

  const {
    match,
    commonStore,
    loadingAnimationStore,
    sameDocumentStore,
    connectedDocumentStore,
    aclStore,
  } = props

  const { documentCode } = match.params
  const [document, setDocument] = useState(null)
  const [attachmentForView, setAttachmentForView] = useState()

  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })

  const {
    attachments,
    documentNumber,
    authorityIssuedName,
    dateIssued,
    signer,
    leader,
    handler,
    coordinator,
    startDate,
    endDate,
    start_date,
    end_date,
    status,
    title,
    sameDocumentCode,
  } = document || {}

  const documentStartDate = startDate || start_date
  const documentEndDate = endDate || end_date

  useEffect(() => {
    sameDocumentStore.setDataSameDocument({})
    connectedDocumentStore.setDataReceiveDocument({})
  }, [])

  useEffect(() => {
    fetchData()
    return () => {
      form.resetFields()
    }
  }, [documentCode])

  const fetchData = () => {
    loadingAnimationStore.showSpinner(true)
    sameDocumentStore
      .getDocumentsIncomingById(documentCode)
      .then(response => {
        setDocument(response.data)
      })
      .catch(err => {
        props.history.push('/same-document/incoming-document')
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      })
      .finally(() => loadingAnimationStore.showSpinner(false))
  }

  const reloadIncoming = () => {
    sameDocumentStore
      .reloadIncoming({ code: sameDocumentCode })
      .then(response => {
        fetchData()
      })
      .catch(err => {
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      })
      .finally(() => loadingAnimationStore.showSpinner(false))
  }

  useEffect(() => {
    if (!attachments) return
    setAttachmentForView(
      attachments.find(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.fileName))
      )
    )
  }, [attachments])

  const renderAttachmentFile = useMemo(
    () => (
      <PDFViewer
        fileId={attachmentForView?.fileId}
        file={undefined}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={utils.getExtensionFile(attachmentForView?.fileName)}
      />
    ),
    [attachmentForView]
  )

  const handleClickProcessDocument = () => {
    if (document?.attachments?.length > 0) {
      document?.attachments?.forEach(file => {
        file.name = file.fileName
      })
    }
    sameDocumentStore.setDataSameDocument(document)
    loadingAnimationStore.showSpinner(true)
    sameDocumentStore
      .updateReceivedStatus({ code: documentCode, status: 'COMPLETED' })
      .then(() => {
        message.success('Đã xử lý văn bản!')
      })
      .catch(error => {
        console.log(error)
        message.error(error.vi)
      })
      .finally(() => {
        loadingAnimationStore.showSpinner(false)
      })
    props.history.push('/internal-document/incoming-document/create')
  }

  const documentHandleDropdown = (
    <Menu>
      {status == 'NEW' &&
        aclStore.checkAccessControlAction(
          ACL_ACTION_TYPE.receive__SAME_DOCUMENT
        ) && (
          <Menu.Item
            icon={<InboxOutlined style={{ color: blue }} />}
            onClick={() => handleReceived()}>
            <span style={{ color: blue }}>Nhận văn bản</span>
          </Menu.Item>
        )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.nap_lai__SAME_DOCUMENT
      ) && (
        <Menu.Item
          icon={<ReloadOutlined style={{ color: blue }} />}
          onClick={reloadIncoming}>
          <span style={{ color: blue }}>Nạp lại văn bản</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.xuly__SAME_DOCUMENT
      ) && (
        <Menu.Item
          icon={<ProfileOutlined style={{ color: blue }} />}
          onClick={handleClickProcessDocument}>
          <span style={{ color: blue }}>Xử lý văn bản</span>
        </Menu.Item>
      )}
    </Menu>
  )

  const handleReceived = () => {
    loadingAnimationStore.showSpinner(true)
    sameDocumentStore
      .updateReceivedStatus({ code: documentCode, status: 'ACCEPT' })
      .then(() => {
        message.success('Nhận văn bản thành công!')
        fetchData()
      })
      .catch(error => {
        console.log(error)
        message.error(error.vi)
      })
      .finally(() => {
        loadingAnimationStore.showSpinner(false)
      })
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>{`${title} | ${systemName} Quản lý VB nội bộ`}</title>
      </Helmet>

      <PageTitle
        location={props.location}
        title={title ? title : 'Undefined'}
        showTitle={true}
        color={commonStore.appTheme.solidColor}>
        <HeadingButtonWrapper>
          <Dropdown overlay={documentHandleDropdown} trigger={['click']}>
            <span className={'btn-style'}>
              <MoreOutlined />
            </span>
          </Dropdown>
        </HeadingButtonWrapper>
      </PageTitle>
      <DocumentContentWrapper>
        <BlockLeft>{renderAttachmentFile}</BlockLeft>

        <BlockRight>
          <ContentBlockWrapper>
            <TitleContentBox>Thông tin chung</TitleContentBox>
            <DocumentInfoList>
              <dt>Số hiệu</dt>
              <dd>{documentNumber && documentNumber}</dd>
              <dt>CQ ban hành</dt>
              <dd>{authorityIssuedName && WordBreak(authorityIssuedName)}</dd>
              <dt>Ngày ban hành</dt>
              <dd>
                {dateIssued && (
                  <>
                    <CalendarOutlined style={{ color: blue, marginRight: 4 }} />
                    <span>
                      {moment(dateIssued).format(DATE_FORMAT_DEFAULT)}
                    </span>
                  </>
                )}
              </dd>
              <dt>Người ký</dt>
              <dd>{signer || <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>}</dd>
              <dt>Lãnh đạo xử lý</dt>
              <dd>{leader || <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>}</dd>
              <dt>Người xử lý</dt>
              <dd>{handler || <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>}</dd>
              <dt>Phối hợp/ Theo dõi</dt>
              <dd>{coordinator || <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>}</dd>
              <dt>Ngày bắt đầu</dt>
              <dd>
                {documentStartDate ? (
                  <>
                    <CalendarOutlined style={{ color: blue, marginRight: 4 }} />
                    <span>
                      {moment(documentStartDate).format(DATE_FORMAT_DEFAULT)}
                    </span>
                  </>
                ) : (
                  <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không rõ.</span>
                )}
              </dd>
              <dt>Ngày kết thúc</dt>
              <dd>
                {documentEndDate ? (
                  <>
                    <CalendarOutlined style={{ color: blue, marginRight: 4 }} />
                    <span>
                      {moment(documentEndDate).format(DATE_FORMAT_DEFAULT)}
                    </span>
                  </>
                ) : (
                  <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không rõ.</span>
                )}
              </dd>
              <dt>Trạng thái</dt>
              <dd>{getDOCUMENT_SAME_STATUS_RECEIVED(status)}</dd>

              <dt>Tài liệu đính kèm</dt>
              <dd>
                <div>
                  {attachments ? (
                    attachments.map(file => (
                      <FileItem
                        key={file.fileId}
                        file_id={file.fileId}
                        file_name={file.fileName}
                        file_type={utils.getExtensionFile(file.fileName)}
                      />
                    ))
                  ) : (
                    <EmptyText>Không có tài liệu đính kèm.</EmptyText>
                  )}
                </div>
              </dd>
            </DocumentInfoList>
          </ContentBlockWrapper>
          <div style={{ marginBottom: 15 }} />
        </BlockRight>
      </DocumentContentWrapper>
    </DashboardLayout>
  )
}

SameDocumentIncomingDocDetailPage.propTypes = {}

export default inject(
  'commonStore',
  'sameDocumentStore',
  'loadingAnimationStore',
  'authenticationStore',
  'connectedDocumentStore',
  'aclStore'
)(observer(SameDocumentIncomingDocDetailPage))
